"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PLATFORM = void 0;

var _v = _interopRequireDefault(require("uuid/v1"));

var _TransformResponse = _interopRequireDefault(require("./helpers/TransformResponse"));

var _ConfigHelper = _interopRequireDefault(require("./helpers/ConfigHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('es6-promise').polyfill();

require('isomorphic-fetch');

var singleton = Symbol('client');
var singletonEnforcer = Symbol('client-enforcer');
var CS_ANNOT_CONTENT_TYPE = 'application/ld+json; profile="https://www.w3.org/ns/anno.jsonld"';
var CS_ANON_CONTENT_TYPE = 'application/vnd.adobe.dc+json;profile="https://comments.acrobat.com/schemas/anon_session_req_v1.json"';
var CS_ANON_ACCEPT = 'application/vnd.adobe.dc+json;profile="https://comments.acrobat.com/schemas/anon_session_res_v1.json"';
var CS_DC_ACL_CONTENT_TYPE = 'application/vnd.adobe.dc+json;profile="https://comments.acrobat.com/schemas/acl_v1.json"';
var CS_PREFER = 'return=representation;include="https://www.w3.org/ns/oa#PreferContainedDescriptions"';
var CS_BATCH_ANNOT_CONTENT_TYPE = 'application/json; profile="https://comments.adobe.io/schemas/bulk_entity_v1.json"';
var ACP_ANNOT_CONTENT_TYPE = 'application/vnd.adobe.annotation+json';
var ACP_ANNOTS_CONTENT_TYPE = 'application/vnd.adobe.annotations+json';
var PLATFORM = {
  ACP: 'acp',
  SC: 'sc'
};
/**
 * HttpError wrapper.
 */

exports.PLATFORM = PLATFORM;

var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);

  var _super = _createSuper(HttpError);

  /**
   * A constructor.
   * @param   {string}  message   error message
   * @param   {int}  httpCode  http status code
   */
  function HttpError(message, httpCode) {
    var _this;

    _classCallCheck(this, HttpError);

    _this = _super.call(this, message);
    _this.status = httpCode;
    return _this;
  }

  return HttpError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Create the Client singleton. This class controls the configuration of the SDK, and
 * communicates with the legacy or ACP Redhawk Commenting service API.
 */


var Client = /*#__PURE__*/function () {
  /**
   * @access private
   * @param  {Symbol} enforcer Enforced singleton
   */
  function Client(enforcer) {
    _classCallCheck(this, Client);

    this._commentsApiUrl = null;
    this._token = null;
    this._userId = null;
    this._environment = 'dev';
    this._clientId = 'CCXCommentsSDK';
    this._disableGetAuthorization = false;
    this._commentType = null;
    this._pollForUpdates = false;
    this._platform = null;
    this._isACP = false;
    this._lastAssetId = null;
    this._lastPath = null;
    this._lastAnnotDiscoveryUrl = null;
    this._validNodes = null;
    this.assetId = false;
    this.isCCXWorkflow = false;
    this._useNodeIndex = false;

    if (enforcer !== singletonEnforcer) {
      // eslint-disable-next-line no-throw-literal
      throw new Error('Cannot create singleton');
    }
  }
  /**
   * Get the single instance of the Client class.
   *
   * @access private
   * @return {Object} instance The single instance of the Client class.
   */


  _createClass(Client, [{
    key: "configure",

    /**
     * @param  {Object} settings The settings object.
     * @example <caption>Configuring the client</caption>
     * Client.instance.configure({
     *   environment: 'stage',
     *   token: 'Bearer <token>'
     * });
     * @return {undefined}
     */
    value: function configure(settings) {
      if (settings.platform !== undefined) {
        this.platform = settings.platform;
      }

      this.isACP = this._platform !== undefined && this._platform !== null && this._platform.startsWith(PLATFORM.ACP);

      if (settings.token) {
        this.token = settings.token;
      }

      if (settings.appKey) {
        this.appKey = settings.appKey;
      }

      if (settings.appName && !this.appName) {
        this.appName = settings.appName;
      }

      if (settings.userId) {
        this.userId = settings.userId;
      }

      if (settings.environment) {
        this.environment = settings.environment;
      }

      if (settings.clientId) {
        this.clientId = settings.clientId;
      }

      if (settings.disableGetAuthorization !== undefined) {
        this.disableGetAuthorization = settings.disableGetAuthorization;
      }

      if (settings.pollForUpdates !== undefined) {
        this.pollForUpdates = settings.pollForUpdates;
      }

      if (settings.validNodes !== undefined) {
        this.validNodes = settings.validNodes;
      }

      if (settings.assetId !== undefined) {
        this.assetId = settings.assetId;
      }

      if (settings.useNodeIndex !== undefined) {
        this.useNodeIndex = settings.useNodeIndex;
      }

      if (settings.commentType) {
        var type;

        if (_typeof(settings.commentType) === 'object' && settings.commentType.length) {
          type = settings.commentType.join();
        } else if (typeof settings.commentType === 'string') {
          type = settings.commentType;
        }

        this.commentType = type;
      }

      if (settings.isCCXWorkflow !== undefined) {
        this.isCCXWorkflow = Boolean(settings.isCCXWorkflow);
      }

      if (settings.invitationServiceAccessToken !== undefined) {
        this.invitationServiceAccessToken = settings.invitationServiceAccessToken;
      }
    }
    /**
     * Set the comments api url
     *
     * @param  {string} environment current configured value for the environment
     * @example <caption>Setup the comments api URL based on enviroment</caption>
     * @return {undefined}
     */

  }, {
    key: "setCommentsApiUrl",
    value: function setCommentsApiUrl(environment) {
      var env;

      if (environment.startsWith('de')) {
        env = 'dev';
      } else if (environment.startsWith('st')) {
        env = 'stage';
      } else if (environment.startsWith('pr')) {
        env = 'prod';
      } else {
        throw new Error("unknown env: ".concat(environment));
      } // Load the configuration.


      var options = (0, _ConfigHelper["default"])(env); // Resolve to the correct url;

      this.commentsApiUrl = this.isACP ? options.COMMENTS_ENDPOINT_ACPS : options.COMMENTS_ENDPOINT; // Invalidate cache.

      this._lastAssetId = null;
    }
    /**
     * Set the token
     *
     * @param {String} token The new token
     * @example <caption>Setting the token</caption>
     * Client.instance.token = 'Bearer <token>';
     */

  }, {
    key: "request",

    /**
     * Performs a request for the given parameters and returns an appropriately transformed response
     * depending on the platform configuration.
     * @access private
     * @param  {String} assetId URN of requesting object
     * @param  {String} type Describes the invoking request
     * @param  {String} url The API endpoint
     * @param  {String} method HTTP request types
     * @param  {Object} body The body object
     * @param  {Object} headers HTTP headers to be applied to request
     * @returns {Object} The request result
     */
    value: function request(assetId, type, url, method, body, headers) {
      var _this2 = this;

      return this.fetch(assetId, type, url, method, body, headers).then(function (results) {
        if (results) {
          if (results.data) {
            // Transform to model.
            var tr = new _TransformResponse["default"](_this2.isACP, url, results);
            return tr.transform();
          } // Return raw (may be an empty object that includes headers)


          return results;
        }

        return null;
      });
    }
    /**
     * Helper for authorization token formatting.
     *
     * @return  {string}  formatted token suitable for headers
     */

  }, {
    key: "formatAuthorizationToken",
    value: function formatAuthorizationToken() {
      if (this._token) {
        return this._token.indexOf('Bearer ') > -1 ? this._token : "Bearer ".concat(this._token);
      }

      return '';
    }
    /**
     * Constructs fetch for the given parameters.
     * @access private
     * @param  {String} assetId URN of requesting object
     * @param  {String} type Describes the invoking request
     * @param  {String} url The API endpoint
     * @param  {String} method HTTP request types
     * @param  {Object} body The body object
     * @param  {Object} headers HTTP headers to be applied to request
     * @returns {Object} The request result
     */

  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2, _x3, _x4, _x5, _x6) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (assetId, type, url, method, body, headers) {
      var _headers = {};

      if (this.isACP) {
        if (type === 'asset.get' || type === 'asset.getResolved') {
          _headers.Accept = ACP_ANNOTS_CONTENT_TYPE;
        } else {
          _headers.Accept = ACP_ANNOT_CONTENT_TYPE;
        }

        if (method !== 'GET' && method !== 'get') {
          _headers['Content-Type'] = ACP_ANNOT_CONTENT_TYPE;
        }
      } else if (type === 'asset.batchRemap') {
        _headers['Content-Type'] = CS_BATCH_ANNOT_CONTENT_TYPE;
        _headers.Accept = CS_BATCH_ANNOT_CONTENT_TYPE;
      } else {
        _headers['Content-Type'] = CS_ANNOT_CONTENT_TYPE;
        _headers.Accept = url.indexOf('annots/acl') > -1 ? CS_DC_ACL_CONTENT_TYPE : CS_ANNOT_CONTENT_TYPE;
        _headers.Prefer = CS_PREFER;
      }

      if (this._token) {
        _headers.Authorization = this.formatAuthorizationToken();
      }

      if (type === 'asset.get' && this._disableGetAuthorization) {
        _headers.Authorization = null;
      }

      if (headers && headers['If-None-Match']) {
        _headers['If-None-Match'] = headers['If-None-Match'];
      } else if (headers && headers['If-Match']) {
        _headers['If-Match'] = headers['If-Match'];
      }

      if (headers && headers.Accept) {
        _headers.Accept = headers.Accept;
      }

      if (headers && headers['Content-Type']) {
        _headers['Content-Type'] = headers['Content-Type'];
      }

      if (this._appKey) {
        _headers['x-api-key'] = this._appKey; // Allow for Redhawk to use AdobeIDs for mentions in comment text

        _headers['x-mentions'] = 'true';
      }

      if (this.appName) {
        _headers['x-api-app-info'] = this.appName;
      }

      if (typeof method !== 'string') {
        throw new Error('method must be defined');
      } // Check if we have a token for non-GET calls.


      if (method !== 'GET' && !this._token) {
        throw new Error('Authorization not configured. Please set the bearer token before calling this method.');
      }

      if (this.isCCXWorkflow) {
        _headers['x-ccx-workflow'] = 'true';
      }

      if (this.invitationServiceAccessToken) {
        _headers['X-Access-Token'] = this.invitationServiceAccessToken;
        _headers['X-Feature-Override'] = 'ValidateCapabilitiesPassword';
      }

      var requestId = (0, _v["default"])();
      _headers['x-request-id'] = headers['x-request-id'] || requestId;

      var checkStatus = function checkStatus(response) {
        // Check the status, respond
        if (response.status >= 200 && response.status < 300) {
          return response;
        }

        var xrequestid = response.headers.get('x-request-id');
        throw new HttpError("".concat(response.status, " - ").concat(response.statusText, " x-request-id [").concat(xrequestid, "] on URL [").concat(response.url, "]"), response.status);
      };

      var parseJSON = function parseJSON(response) {
        var etag = response.headers.get('ETag');
        var retryAfter = response.headers.get('Retry-After');
        var link = response.headers.get('Link');
        return new Promise(function (resolve) {
          var TEXT_RESPONSES = [204, 208, 304, 429];

          if (TEXT_RESPONSES.indexOf(response.status) > -1) {
            response.text().then(function () {
              resolve({
                retryAfter: retryAfter
              });
            });
          } else {
            response.json().then(function (data) {
              resolve({
                data: data,
                headers: {
                  etag: etag,
                  retryAfter: retryAfter,
                  link: link
                }
              });
            });
          }
        });
      }; // Inject discovery if required.


      return this.getAnnotEndPoint(assetId, url).then(function (annotUrl) {
        return fetch(annotUrl, {
          method: method,
          headers: _headers,
          body: body ? JSON.stringify(body) : undefined
        });
      }).then(function (result) {
        return checkStatus(result);
      }).then(function (result) {
        return parseJSON(result);
      })["catch"](function (err) {
        err.message = "".concat(err.message, " - x-request-id [").concat(requestId, "]");
        return Promise.reject(err);
      });
    })
    /**
     * Function to flatten a tested object to a single level.
     * @param {Object} nestedObj Nested object to be flattened
     * @param {Object} flatObj the object in the process of being flattened
     * @param {string} curPrefix the prefix for the key containing all previous level keys
     * @returns {Object} Flattened
     */

  }, {
    key: "flattenObj",
    value: function flattenObj(nestedObj, flatObj, curPrefix) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (var key in nestedObj) {
        var value = nestedObj[key];
        var newKey = curPrefix ? "".concat(curPrefix, ".").concat(key) : key;

        if (value && _typeof(value) === 'object') {
          this.flattenObj(value, flatObj, newKey);
        } else {
          flatObj[newKey] = value;
        }
      }

      return flatObj;
    }
    /**
     * Creates an anonyous session.
     * @param  {Object} guestInfo Object containing required data for creating an anonymous session with redhawk.
     * @param  {Boolean} isRestoringGuestSession boolean indicating if the session is being restored.
     * @example <caption>Generate anonymous redhawk session</caption>
     * Client.instance.createAnonymousSession({
     *   userName: '<user entered name>',
     *   captchaSiteKey: 'public site key specific to site hosting reCaptcha',
     *   captchaResponseCode: '<reCaptcha generated code to be sent to redhawk for authentication>'
     * });
     * @returns {Promise} result
     */

  }, {
    key: "createAnonymousSession",
    value: function createAnonymousSession(guestInfo, isRestoringGuestSession) {
      var xrequestid = (0, _v["default"])();
      var _headers = {
        'Content-Type': CS_ANON_CONTENT_TYPE,
        Accept: CS_ANON_ACCEPT,
        'x-request-id': xrequestid
      };

      if (this.appKey) {
        _headers['x-api-key'] = this.appKey;
      }

      if (this.appName) {
        _headers['x-api-app-info'] = this.appName;
      }

      if (isRestoringGuestSession) {
        _headers.Authorization = this.formatAuthorizationToken();
        delete guestInfo.userName;
      }

      var _url = "".concat(this.commentsApiUrl).concat(isRestoringGuestSession ? 'refresh_anonymous_session' : 'create_anonymous_session');

      if (!guestInfo || !guestInfo.userName && !isRestoringGuestSession) {
        throw new Error('Guest username not provided. Please provide a username before calling this method.');
      }

      if (!guestInfo.captchaSiteKey) {
        throw new Error('reCaptcha site key not provided. Please provide a reCaptcha site key before calling this method.');
      }

      if (!guestInfo.captchaResponseCode) {
        throw new Error('reCaptcha response code not provided. Please provide a reCaptcha response code before calling this method.');
      }

      var checkStatus = function checkStatus(response) {
        return new Promise(function (resolve, reject) {
          if (response.status === 201) {
            response.json().then(function (data) {
              if (data.ticket && data.id) {
                resolve({
                  token: "AnonBearer ".concat(data.ticket),
                  id: data.id,
                  expires: response.headers.get('expires')
                });
              } else {
                reject(new Error('missing data.ticket or .id'));
              }
            });
          } else {
            var msg = response.statusText ? "".concat(response.status, " - ").concat(response.statusText, " x-request-id [").concat(xrequestid, "] on URL [").concat(response.url, "]") : response;
            reject(new HttpError(msg, response.status));
          }
        });
      };

      return fetch(_url, {
        method: 'POST',
        headers: _headers,
        body: JSON.stringify(guestInfo)
      }).then(checkStatus)["catch"](checkStatus);
    }
    /**
     * Helper for url segment concats
     *
     * @param   {string}  s1 First
     * @param   {string}  s2 Second
     * @return  {string}      concatonated string
     */

  }, {
    key: "joinPath",
    value: function joinPath(s1, s2) {
      if (s1 && s1.endsWith('/')) {
        return s2.startsWith('/') ? s1 + s2.substring(1) : s1 + s2;
      }

      return s2.startsWith('/') ? s1 + s2 : "".concat(s1, "/").concat(s2);
    }
    /**
     * Provides an endpoint given the asset-id and a path segment.  For ACP,
     * an additional ACP discovery step is taken given the current environment and region in order
     * to obtain the operational redhawk commenting service base endpoint from which all
     * API requests are formed.  For legacy, original behaviour is observed.
     *
     * If path is absolute, this is returned directly.
     * If the asset and path were previously served, the cached endpoint is returned.
     *
     * @param   {string}  assetId  The asset from which to discover the endpoint
     * @param   {string}  path     Optional path
     *
     * @return  {promise}          Promise resolves as the endpoint
     */

  }, {
    key: "getAnnotEndPoint",
    value: function getAnnotEndPoint(assetId, path) {
      var _this3 = this;

      // Path may be fully specified to due ACP discovery links.
      if (path.startsWith('http')) {
        return new Promise(function (resolve) {
          resolve(path);
        });
      }

      var that = this;

      if (assetId === this._lastAssetId && path === this._lastPath) {
        return new Promise(function (resolve) {
          resolve(that._lastAnnotDiscoveryUrl);
        });
      }

      var ep = this.joinPath(this.commentsApiUrl, path);

      if (this.isACP) {
        // Discovery step performed first based on location of asset.
        return this.discoverAnnotEndPoint(assetId) // eslint-disable-next-line consistent-return
        .then(function (result) {
          if (result) {
            var paramsIndex = result.lastIndexOf('?'); // Adjust url if endPoint has params to insert optional path segment if provided.

            if (paramsIndex > 0) {
              var params = result.substring(paramsIndex);
              ep = result.substring(0, paramsIndex);
              ep = _this3.joinPath(ep, path);
              ep += path.includes('?') ? params.replace('?', '&') : params;
            } // Cache


            that._lastAssetId = assetId;
            that._lastAnnotDiscoveryUrl = ep;
            that._lastPath = path;
            return Promise.resolve(ep);
          }
        })["catch"](function (reason) {
          return Promise.reject(new Error("getAnnotEndPoint(): [".concat(reason.message, "]")));
        });
      }

      return new Promise(function (resolve) {
        resolve(ep);
      });
    }
    /**
     * Helper to return links collection.
     *
     * @param {Object} response Header string to be parsed
     *
     * @return  {string[]} Links array.
     */

  }, {
    key: "getLinks",
    value: function getLinks(response) {
      var linkString = response.headers.get('link');
      return linkString ? linkString.split('<') : [];
    }
    /**
     * Performs API discovery using provided asset-id and environment.
     *
     * @param   {string}  assetId URN of asset
     *
     * @return  {promise} Promise resolved as path to redhawk commenting service.
     */

  }, {
    key: "discoverAnnotEndPoint",
    value: function discoverAnnotEndPoint(assetId) {
      var _this4 = this;

      var LINKREL = 'http://ns.adobe.com/adobecloud/rel/annotations';
      var _headers = {
        Authorization: this.formatAuthorizationToken(),
        'X-Api-Key': this.appKey,
        Accept: '*/*',
        Connection: 'keep-alive'
      }; // Add random() to solve HEAD caching in firefox since
      // cache headers are blocked via cors list.

      var discoveryUrl = this.joinPath(this.commentsApiUrl, "/content/directory/resolve?id=".concat(assetId, "&random=").concat(Math.random()));
      return fetch(discoveryUrl, {
        method: 'HEAD',
        headers: _headers
      }).then(function (result) {
        if (result.status >= 200 && result.status < 300) {
          var links = _this4.getLinks(result);

          for (var count = 0; count < links.length; count += 1) {
            var item = links[count];

            if (item && item.includes(LINKREL)) {
              var src = item.substring(0, item.indexOf('>'));
              return Promise.resolve(src);
            }
          }

          return Promise.reject(new Error("annotation link url not found in collection [size: ".concat(links.length, "]")));
        }

        return Promise.reject(new Error("".concat(result.status, " ").concat(result.statusText, " ").concat(result.url)));
      })["catch"](function (err) {
        return Promise.reject(new Error("discoverAnnotEndPoint() fetch: ".concat(err.message)));
      });
    }
  }, {
    key: "token",
    set: function set(token) {
      this._token = token;
    }
    /**
     * Get the token
     *
     * @return {String} The current token
     * @example <caption>Get the token</caption>
     * let token = Client.instance.token;
     */
    ,
    get: function get() {
      return this._token;
    }
    /**
     * Switches sdk api to ACP API and payloads.
     *
     * @param   {string}  value  One of PLATFORM.ACP or .SC
     *
     */

  }, {
    key: "platform",
    set: function set(value) {
      this._platform = value;
    }
    /**
     * Platform value.
     *
     * @return  {String}  value  One of PLATFORM.ACP or .SC
     */
    ,
    get: function get() {
      return this._platform;
    }
    /**
     * Sets in ACP mode
     *
     * @param   {bool}  value True = acp
     */

  }, {
    key: "isACP",
    set: function set(value) {
      this._isACP = value;
    }
    /**
     * Platform operating mode.
     *
     * @return  {bool}  True if platform is ACP.
     */
    ,
    get: function get() {
      return this._isACP;
    }
    /**
     * Url base for commenting service.
     *
     * @param   {string}  value  The base url
     */

  }, {
    key: "commentsApiUrl",
    set: function set(value) {
      this._commentsApiUrl = value;
    }
    /**
     * Returns Url base for commenting service.
     *
     * @return  {String}  The base url
     */
    ,
    get: function get() {
      return this._commentsApiUrl;
    }
    /**
     * Set the user Id.
     *
     * @param {String} userId The new user ID
     */

  }, {
    key: "userId",
    set: function set(userId) {
      this._userId = userId;
    }
    /**
     * Get the user Id
     *
     * @return {String} The current user Id
     * @example <caption>Get the user Id</caption>
     * let userId = Client.instance.userId;
     */
    ,
    get: function get() {
      return this._userId;
    }
    /**
     * Set the environment
     *
     * @param {String} environment The new environment
     * @example <caption>Setting the environment</caption>
     * Client.instance.environment = 'stage';
     */

  }, {
    key: "environment",
    set: function set(environment) {
      var acceptedEnvironments = ['dev', 'development', 'stage', 'prod', 'production'];
      var acceptedEnvironmentsString = ''; // Create the string based on acceptedEnvironments.

      acceptedEnvironments.forEach(function (acceptedEnvironment, index) {
        var endString = index + 1 === acceptedEnvironments.length ? '' : ', ';
        acceptedEnvironmentsString += acceptedEnvironment + endString;
      }); // If the value specified is not accepted, throw an error.

      if (acceptedEnvironments.indexOf(environment) === -1) {
        throw new Error("Setting the environment to ".concat(environment, " is not accepted. Acceptable values are ").concat(acceptedEnvironmentsString)); // Otherwise, set the comments API url
      } else {
        this.setCommentsApiUrl(environment);
      } // Set the environment variable


      this._environment = environment;
    }
    /**
     * Get the environment
     *
     * @return {String} The current environment
     * @example <caption>Get the environment</caption>
     * let environment = Client.instance.environment;
     */
    ,
    get: function get() {
      return this._environment;
    }
    /**
     * Set the client ID. This is used in analytics calls to differentiate from the default.
     *
     * @param {String} clientId The new clientId
     * @example <caption>Setting the client ID</caption>
     * Client.instance.clientId = 'MyClientId';
     */

  }, {
    key: "clientId",
    set: function set(clientId) {
      // Set the clientId variable
      this._clientId = clientId;
    }
    /**
     * Get the clientId
     *
     * @return {String} The current clientId
     * @example <caption>Get the client ID</caption>
     * let clientId = Client.instance.clientId;
     */
    ,
    get: function get() {
      return this._clientId;
    }
    /**
     * Enable or disable use of the Authorization token for getting comments.
     *
     * @param {Boolean} authorizationFlag Flag to disable/enable authorization token.
     * @example <caption>Disabling authorization on get</caption>
     * Client.instance.disableGetAuthorization = true;
     */

  }, {
    key: "disableGetAuthorization",
    set: function set(authorizationFlag) {
      // Set the disableGetAuthorization variable
      this._disableGetAuthorization = authorizationFlag;
    }
    /**
     * Return whether using the authorization token is enabled for getting comments.
     *
     * @return {Boolean} The current state of disableGetAuthorization
     * @example <caption>Get the state of disableGetAuthorization</caption>
     * let getAuthorizationDisabled = Client.instance.disableGetAuthorization;
     */
    ,
    get: function get() {
      return this._disableGetAuthorization;
    }
    /**
     * Set the value for if we should enable polling for comments
     *
     * @param {boolean} value to use to determine if we should poll for updates
     * @example <caption>Setting the boolean to indicate if we should poll for updates on get</caption>
     * Client.instance.pollForUpdates = true;
     */

  }, {
    key: "pollForUpdates",
    set: function set(value) {
      // Set the pollForUpdates variable
      this._pollForUpdates = value;
    }
    /**
     * Return the value being used for if we should enable polling for comments
     *
     * @return {Boolean} value to use to determine if we should poll for updates
     * @example <caption>Get the state of the poll for updates</caption>
     * let getPollForUpdates = Client.instance.pollForUpdates;
     */
    ,
    get: function get() {
      return this._pollForUpdates;
    }
    /**
     * Set the value for valid nodes array
     *
     * @param {Array} value to use to for the valid nodes array
     * @example <caption>Setting the array for the valid nodes</caption>
     * Client.instance.validNodes = [{id: '123', name: 'First Node'}, {id: '456', name: 'Second Node'}]
     */

  }, {
    key: "validNodes",
    set: function set(value) {
      // Set the validNodes variable
      this._validNodes = value;
    }
    /**
     * Return the value being used for valid nodes array
     *
     * @return {Array} value to use to for the valid nodes array
     * @example <caption>Get the state of the valid nodes array</caption>
     * let getValidNodes = Client.instance.validNodes;
     */
    ,
    get: function get() {
      return this._validNodes;
    }
    /**
     * Set the value for use node index
     *
     * @param {Array} value to use to for use node index
     * @example <caption>Setting the use node index value</caption>
     * Client.instance.useNodeIndex = true
     */

  }, {
    key: "useNodeIndex",
    set: function set(value) {
      // Set the useNodeIndex variable
      this._useNodeIndex = value;
    }
    /**
     * Return the value being used for use node index
     *
     * @return {Array} value to use to for use node index
     * @example <caption>Get the state of use node index</caption>
     * let getUseNodeIndex = Client.instance.useNodeIndex;
     */
    ,
    get: function get() {
      return this._useNodeIndex;
    }
    /**
     * Set the value being used for the x-api-key header
     *
     * @param {Number} value to use for the appKey
     * @example <caption>Setting the appKey on get</caption>
     * Client.instance.appKey = 10000;
     */

  }, {
    key: "appKey",
    set: function set(value) {
      var newAppKey = value;

      if (!value && this.environment !== 'prod' && this.environment !== 'production') {
        console.error('Application key missing. Commenting will fail in production enviromnents.');
        newAppKey = 'CCXCommenting';
      } // Set the appKey variable


      this._appKey = newAppKey;
    }
    /**
     * Return the value being used for the x-api-key header
     *
     * @return {Boolean} The current value of the appKey
     * @example <caption>Get the state of the appKey</caption>
     * let getappKey = Client.instance.appKey;
     */
    ,
    get: function get() {
      return this._appKey;
    }
    /**
     * Set the value being used for the x-api-app-info header
     *
     * @param {Number} value to use for the appName
     * @example <caption>Setting the appName on get</caption>
     * Client.instance.appName = 10000;
     */

  }, {
    key: "appName",
    set: function set(value) {
      if (!value && this.environment !== 'prod' && this.environment !== 'production') {
        console.warn('Application name missing. Please provide a name for reliable logging for your application.');
      } // Set the appName variable


      this._appName = value;
    }
    /**
     * Return the value being used for the x-api-app-info header
     *
     * @return {Boolean} The current value of the appNames
     * @example <caption>Get the appName value</caption>
     * let getappName = Client.instance.appName;
     */
    ,
    get: function get() {
      return this._appName;
    }
    /**
     * Configure the client to request different types of comments from the api.
     *
     * @param {String|Array} commentType Either a string or array of the types of comments to fetch.
     * @example <caption>Setting different comment types for the request</caption>
     * Client.instance.commentType = ['open', 'resolved'];
     */

  }, {
    key: "commentType",
    set: function set(commentType) {
      var type = null;

      if (commentType) {
        if (_typeof(commentType) === 'object' && commentType.length) {
          type = commentType.join();
        } else if (typeof commentType === 'string') {
          type = commentType;
        }
      } // Set the commentType variable


      this._commentType = type;
    }
    /**
     * Return the string of comment types that need to be requested
     *
     * @return {String} The current state of commentType
     * @example <caption>Get the state of commentType</caption>
     * let commentType = Client.instance.commentType;
     */
    ,
    get: function get() {
      return this._commentType;
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new Client(singletonEnforcer);
      }

      return this[singleton];
    }
  }]);

  return Client;
}();
/**
 * Exports the Client class.
 */


var _default = Client;
exports["default"] = _default;